// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridItemProps } from "@insite/mobius/GridItem";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { CSSProperties, useState } from "react";
import styled, { css } from "styled-components";

interface OwnProps extends WidgetProps {
    fields: {
        [fields.iframeSrc]: string;
        [fields.paddingTopExtraSmall]: number;
        [fields.paddingTopSmall]: number;
        [fields.paddingTopMedium]: number;
        [fields.paddingTopLarge]: number;
    };
}

const enum fields {
    iframeSrc = "iframeSrc",
    paddingTopExtraSmall = "paddingTopExtraSmall",
    paddingTopSmall = "paddingTopSmall",
    paddingTopMedium = "paddingTopMedium",
    paddingTopLarge = "paddingTopLarge",
}

const StyledIframe = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
`;

export interface SalesforceFormStyles {
    salesforceFormWrapper?: GridItemProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const salesforceFormStyles: SalesforceFormStyles = {
    salesforceFormWrapper: {
        width: [12, 12, 12, 12, 12],
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    centeringWrapper: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
};

const styles = salesforceFormStyles;

const SalesforceForm = ({ fields }: OwnProps) => {
    const { iframeSrc } = fields;

    const [isIframeLoaded, setIframeLoaded] = useState(false);

    const dynamicStyles = {
        salesforceFormWrapper: {
            css: css`
                position: relative;
                padding-top: ${fields.paddingTopExtraSmall}px;

                ${breakpoint("sm")} {
                    padding-top: ${fields.paddingTopSmall}px;
                }

                ${breakpoint("md")} {
                    padding-top: ${fields.paddingTopMedium}px;
                }

                ${breakpoint("lg")} {
                    padding-top: ${fields.paddingTopLarge}px;
                }
            `,
        },
    };

    const mergedStyles = mergeProps(salesforceFormStyles, dynamicStyles);

    return (
        <StyledWrapper {...mergedStyles.salesforceFormWrapper}>
            {!isIframeLoaded && (
                <StyledWrapper {...mergedStyles.centeringWrapper}>
                    <LoadingSpinner {...mergedStyles.spinner} data-test-selector="productListCardListSpinner" />
                </StyledWrapper>
            )}
            <StyledIframe
                frameBorder="0"
                src={iframeSrc}
                onLoad={() => setIframeLoaded(true)}
                style={{ display: "block" }}
            />
        </StyledWrapper>
    );
};

const salesforceForm: WidgetModule = {
    component: SalesforceForm,
    definition: {
        displayName: "Salesforce iFrame Form",
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.iframeSrc,
                editorTemplate: "TextField",
                displayName: "iFrame Source URL",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 0,
                isRequired: true,
            },
            {
                name: fields.paddingTopExtraSmall,
                editorTemplate: "TextField",
                displayName: "Padding Top for Extra Small",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 1,
                isRequired: true,
            },
            {
                name: fields.paddingTopSmall,
                editorTemplate: "TextField",
                displayName: "Padding Top for Small",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 2,
                isRequired: true,
            },
            {
                name: fields.paddingTopMedium,
                editorTemplate: "TextField",
                displayName: "Padding Top for Medium",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 3,
                isRequired: true,
            },
            {
                name: fields.paddingTopLarge,
                editorTemplate: "TextField",
                displayName: "Padding Top for Large",
                defaultValue: "",
                fieldType: "Contextual",
                sortOrder: 4,
                isRequired: true,
            },
        ],
    },
};

export default salesforceForm;
